export default "/images/branding-nlinker.webp?f205b4a07b5a9b46197f6d4653fd86c4";